export const getSelectionLine = () =>
  document.getElementById('selection-line') as HTMLElement;

export const getThumb = () =>
  document.getElementById('billing-plan-thumb') as HTMLElement;
